import axios from "axios";

export const baseURL = "https://payroll-management-system-85aw.onrender.com/api";
export const baseURL_Image = "https://payroll-management-system-85aw.onrender.com/api";

export const instance = axios.create({
  baseURL: baseURL,
});
